import { useCaptcha } from '../../../common/js/composables/captcha';
import playerMascotRegistrationApi from '../../../api/player-mascot-registration-api';

const captchaState = useCaptcha(playerMascotRegistrationApi.captcha);

export const usePlayerMascotRegistrationCaptcha = () => captchaState;
